import React from "react";
import TailwindText, { TailwindTextProps } from "../text";
import { CustomFormatConfig, FormattedDate } from "react-intl";

export type TailwindTranslatedDateProps = Intl.DateTimeFormatOptions &
  CustomFormatConfig & {
    value: string | number | Date | undefined;
  } & {
    textProps?: TailwindTextProps;
  };

const TailwindTranslatedDate: React.ComponentType<TailwindTranslatedDateProps> = ({
  textProps,
  ...props
}) => {
  return (
    <TailwindText {...textProps}>
      <FormattedDate {...props} />
    </TailwindText>
  );
};

export default TailwindTranslatedDate;
